class WishlistButton extends HTMLElement {
  static STORAGE_KEY = 'wishlist_product_ids';

  connectedCallback() {
    this.productHandle = this.dataset.productHandle;
    this.button = this.querySelector('.wishlist-button__toggle');
    this.addLabel = this.querySelector('[data-wishlist-add-label]');
    this.removeLabel = this.querySelector('[data-wishlist-remove-label]');

    this.render();
    this.button?.addEventListener('click', this.toggle.bind(this));
  }

  getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WishlistButton.STORAGE_KEY)) || [];
    } catch (error) {
      return [];
    }
  }

  setWishlist(list) {
    try {
      localStorage.setItem(WishlistButton.STORAGE_KEY, JSON.stringify(list));
    } catch (error) {
      // localStorage unavailable (private browsing, etc.) - fail silently
    }
    window.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { list } }));
  }

  toggle() {
    const list = this.getWishlist();
    const isSaved = list.includes(this.productHandle);
    const updated = isSaved
      ? list.filter((handle) => handle !== this.productHandle)
      : [...list, this.productHandle];
    this.setWishlist(updated);
    this.render();
  }

  render() {
    const isSaved = this.getWishlist().includes(this.productHandle);
    this.classList.toggle('wishlist-button--active', isSaved);
    this.button?.setAttribute('aria-pressed', String(isSaved));
    this.addLabel?.toggleAttribute('hidden', isSaved);
    this.removeLabel?.toggleAttribute('hidden', !isSaved);
  }
}

customElements.define('wishlist-button', WishlistButton);
